import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import { downloadFile } from '@/utils/downloader'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  tree: {
    internal: [],
    external: []
  },
  fetching: false,
  componentKey: getComponentKey()
}

export const actionTypes = {
  DocumentationViewerFetching: 'documentationViewer/fetching',
  DocumentationViewerFetched: 'documentationViewer/fetched',
  Error: 'documentationViewer/errorOccurred'
}

export const actionCreators = {

  loadTree: () => (dispatch) => {
    dispatch({ type: actionTypes.DocumentationViewerFetching })
    context.api.documentationViewerService.get(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.DocumentationViewerFetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.Error }))
  },
  download: (fileAttachment) => () => {
    downloadFile(fileAttachment.id, context.api.documentationViewerService.download)
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DocumentationViewerFetching: return { ...state, fetching: true }
    case actionTypes.DocumentationViewerFetched: return { ...state, fetching: false, tree: action.data, componentKey: getComponentKey() }
    case actionTypes.DocumentationViewerError: return { ...state, fetching: false }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/DocumentationViewer.js